// export const API_URL = 'https://happy-thoughts-technigo.herokuapp.com/thoughts'

// New URL
export const API_URL = 'https://elsisco-happy-thoughts.herokuapp.com/thoughts'

// Dynamic URL (needs to be a function and needs an argument passed to it)

// export const LIKES_URL = (thoughtId) =>
//   `https://happy-thoughts-technigo.herokuapp.com/thoughts/${thoughtId}/like`

// New URL
export const LIKES_URL = (thoughtId) =>
  `https://elsisco-happy-thoughts.herokuapp.com/thoughts/${thoughtId}/like`
